import { render, staticRenderFns } from "./DmTransactionProfileDetails.vue?vue&type=template&id=3b0d6054&scoped=true&"
import script from "./DmTransactionProfileDetails.vue?vue&type=script&lang=js&"
export * from "./DmTransactionProfileDetails.vue?vue&type=script&lang=js&"
import style0 from "./DmTransactionProfileDetails.vue?vue&type=style&index=0&id=3b0d6054&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0d6054",
  null
  
)

export default component.exports